/* models/datetime_slider.js */ function _(require, module, exports, __esModule, __esExport) {
    var _a;
    __esModule();
    // adapted from bokeh
    // https://github.com/bokeh/bokeh/blob/branch-3.7/bokehjs/src/lib/models/widgets/sliders/date_slider.ts
    const templating_1 = require("@bokehjs/core/util/templating");
    const numerical_slider_1 = require("@bokehjs/models/widgets/sliders/numerical_slider");
    const types_1 = require("@bokehjs/core/util/types");
    class DatetimeSliderView extends numerical_slider_1.NumericalSliderView {
        constructor() {
            super(...arguments);
            this.behaviour = "tap";
            this.connected = [true, false];
        }
        _calc_to() {
            const spec = super._calc_to();
            spec.step *= 1000; // step size is in seconds
            return spec;
        }
        _formatter(value, format) {
            if ((0, types_1.isString)(format)) {
                return templating_1.DEFAULT_FORMATTERS.datetime(value, format, {});
            }
            else {
                return format.compute(value);
            }
        }
    }
    exports.DatetimeSliderView = DatetimeSliderView;
    DatetimeSliderView.__name__ = "DatetimeSliderView";
    class DatetimeSlider extends numerical_slider_1.NumericalSlider {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.DatetimeSlider = DatetimeSlider;
    _a = DatetimeSlider;
    DatetimeSlider.__name__ = "DatetimeSlider";
    DatetimeSlider.__module__ = "panel.models.datetime_slider";
    (() => {
        _a.prototype.default_view = DatetimeSliderView;
        _a.override({
            step: 60,
            format: "%d %b %Y %H:%M:%S",
        });
    })();
}
